<template>
  <NuxtLink
    :to="whatsapp.url"
    target="_blank"
    rel="noopener noreferrer"
    class="text-white font-bold py-2 sm:px-4 rounded-full flex items-center justify-center text-center"
    :class="[whatsapp.bgClass, whatsapp.bgHoverClass]"
  >
    <UIcon :name="whatsapp.icon" :class="iconClasses" />
    {{ label }}
  </NuxtLink>
</template>

<script lang="ts" setup>
import { whatsapp } from '@shared/constants'
import { twMerge } from 'tailwind-merge'

type Props = {
  iconClasses?: string
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: () => useI18n().t('pages.becomePartner.readyToJoin.tchatOption'),
})

const iconClasses = computed(() => twMerge('mr-0 size-6', props.iconClasses))
</script>
